<template>
  <div>
    <van-popup
      v-model="popupShow"
      round
      position="bottom"
    >
      <div class="index-index-prefer">
        <div class="index-prefer-header">
          <div>查看券码</div>
          <img
            class="close"
            @click="onPreferShow"
            src="../../assets/image/close@2x.png"
          />
        </div>
        <div class="index-prefer-list">
          <div class="coupon">
            <img
              src="../../assets/image/coupon-bg.png"
              class="bg"
            >
            <div class="top">
              <div
                class="type"
                v-if="couponItem.couponType == 1"
              >满减券x{{couponMessage.availableNum + couponMessage.disabledNum}}张</div>
              <div
                class="type"
                v-if="couponItem.couponType == 2"
              >运费券x{{couponMessage.availableNum +couponMessage.disabledNum}}张</div>
              <div
                class="type"
                v-if="couponItem.couponType == 3"
              >兑换券x{{couponMessage.availableNum + couponMessage.disabledNum}}张</div>
              <div class="left">
                <div class="money">
                  <span>{{couponItem.couponValue}}</span><span class="unit">元</span>
                </div>
              </div>
              <div class="middle">
                <div class="name">{{couponItem.couponName}}</div>
                <div class="time" v-if="couponItem.stackableUse">
                  <span v-if="couponItem.stackableCount == -1">单笔订单可叠加使用</span>
                  <span v-else>单笔订单可叠加{{couponItem.stackableCount}}张</span>
                </div>
                <div class="time">{{couponItem.useTime}}</div>
              </div>
              <div class="right" v-if="isUser">
                <div class="button" @click="goPage()" >立即使用</div>
              </div>
            </div>
            <div class="bottom">
              <div class="content">
                <div :class="['box', boxButton?'show-box':'']">
                  <p class="desc">{{couponItem.limitDesc}}
                    <img
                      class="arrow"
                      src="../../assets/image/arrow-icon-bottom@2x.png"
                      @click="onToggleExplainClick"
                    >
                  </p>
                  <p
                    class="code"
                    v-if="boxButton"
                  >
                    券码：{{couponItem.couponCode}}
                  </p>
                </div>
              </div>
              <div v-if="isUser">
                <div class="qr_code" v-if="couponMessage.appSubOrderItemDetailVoList[0].isAllowedVirtualAfter || couponItem.couponUseChannel.indexOf('3') > -1">
                <!-- <div class="refundButton"  v-if="couponMessage.appSubOrderItemDetailVoList[0].isAllowedVirtualAfter" @click="onVirtualRefundBtn(couponMessage.appSubOrderItemDetailVoList[0])">申请售后</div> -->
                <div class="combination_button" @click="onJumpToQrCodeDetail(couponItem.couponCode)" v-if="couponItem.couponUseChannel.indexOf('3') > -1" >
                  <div class="exchange">
                  <img src="../../assets/image/qrCode.png" >
                  <span>二维码兑换</span>
                  </div>
                <div class="offline">线下商场使用</div>
              </div>
              </div>
              </div>
              
            </div>
          </div>
        </div>
        <div class="bottom-count">
          <div class="count-left">已过期/已使用/已退款：{{couponMessage.disabledNum}}张</div>
          <div class="count-right">可使用:<span>{{couponMessage.availableNum}}</span>张</div>
        </div>
      </div>
    </van-popup>
    <copons ref="copons"></copons>
  </div>
</template>
<script>
import copons from '@/views/coupon/components/coupons'
export default {
  props: {
    data:{
      type :String
    }
  },
  data() {
    return {
      popupShow: false,
      boxButton: false,
      couponMessage:{},
    couponItem:{},
    isUser:false
    };    
  },
  methods: {
    onPreferShow(data) {
      this.popupShow = !this.popupShow;
      if(data.couponMessage){
      this.couponMessage = data.couponMessage
      this.couponItem = data.couponMessage.appSubOrderItemDetailVoList[0].couponCodeVo
      
      }
      if(data.a){
        this.isUser =true
      }
      
    },
    onToggleExplainClick() {
      this.boxButton = !this.boxButton;
    },
    onJumpExchange(couponCode){
      this.$router.push({ name: "userCouponInfo", query: { code: couponCode } })
    },
    onVirtualRefundBtn(t){
      this.$emit('initiateRefund',t, t)
    },
    onJumpToQrCodeDetail(couponCode){
      this.$router.push({ name: "qrCouponInfo", query: { couponCode: couponCode } })
    },
    goPage(){
      this.$refs.copons.jumpToCouponList(this.couponItem)
    }
  },
  components:{copons}
};
</script>
<style lang="less"scoped>
.index-index-prefer {
  font-size: 24px;
  background: #F7F7F7;
}
.index-prefer-header {
  height: 122px;
  line-height: 122px;
  position: relative;
  font-size: 32px;
  text-align: center;
  background-color: #fff;
  >div{
    font-size: 36px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: bold;
  color: #3B3A38;
  }
  .close{
    width: 48px;
  height: 48px;
  position: absolute;
  right: 40px;
  top: 50%;
  transform: translateY(-50%);
  }
}
.index-prefer-list{
  padding: 20px 20px 0 20px;
}
.coupon {
  position: relative;
  margin-top: 20px;
  padding-top: 180px;
  font-size: 28px;
}

.coupon:first-child {
  margin-top: 0;
}

.coupon .bg {
  display: block;
  position: absolute;
  top: 0px;
  left: -10px;
  right: 0;
  z-index: 1;
  width: 730px;
  height: 180px;
  max-width: none;
}

.coupon .top {
  position: absolute;
  top: 0px;
  left: 0;
  right: 0;
  z-index: 2;
  height: 180px;
  display: flex;
  overflow: hidden;
}

.top .type {
  position: absolute;
  top: 20px;
  left: 0;
  z-index: 3;
  font-size: 20px;
 padding:0 15px ;
  height: 34px;
  border-radius: 0 100px 100px 0;
  line-height: 34px;
  text-align: center;
  background: #ccc;
  color: #fff;
  background: linear-gradient(90deg, #FF8200 0%, #FF1414 100%);
}

.top .left {
  width: 210px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.top .middle {
  
  font-size: 28px;
  position: relative;
  color: #333333;
  overflow: hidden;
  padding-right: 44px;
}
.middle .name{
  font-weight: bold;
      font-size: 26px;
      margin-top: 40px;
      font-family: PingFangSC-Medium, PingFang SC;
display: -webkit-box;
overflow: hidden;
text-overflow:ellipsis;
word-break:break-all;
-webkit-box-orient:vertical;
-webkit-line-clamp:2
}
.middle .time{
  font-size: 20px;
      font-weight: 400;
      font-family: PingFangSC-Regular, PingFang SC;
      margin-top: 6px;
      color: #666666;
}
.right{
  display: flex;
}
.right .button{
  position: absolute;
  right: 44px;
  bottom: 20px;
  border-radius: 32px;
      font-size: 24px;
      background: linear-gradient(90deg, #FF8200 0%, #FF1414 100%);
      box-sizing: border-box;
      color: #fff;
      width: 140px;
      height: 50px;
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      display: flex;
      align-items: center;
      justify-content: center;
}
.top .money {
  font-size: 40px;
  font-weight: 500;
  margin-bottom: 10px;
  margin-top: 14px;
  color: #ED3939;
}
.top .condition {
  font-size: 24px;
  color: #ED3939;
  white-space: nowrap;
}
.money .unit {
  font-size: 20px;
  margin-left: 6px;
}
.bottom {
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  border-radius: 0 0 10px 10px;
  overflow: hidden;
  box-sizing: border-box;
}
.bottom .content{
  padding: 24px 34px;
}
.bottom .box{
  height: 40px;
      overflow: hidden;
}
.bottom .show-box{
  height: auto;
}
.show-box .arrow{
  transform: rotate(180deg);
}
.desc{
      min-height: 40px;
      line-height: 40px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      padding-right: 60px;
}
p{
  font-size: 20px;
      position: relative;
      color: #666666;
      padding: 3px 0;
      display: block;
}

.arrow{
  width: 30px;
      height: 30px;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 1;
}
.bottom-count{
  display: flex;
  justify-content: space-between;
  padding:23px 22px 23px 20px
}.count-left{
  color: #999999;
  font-size: 24px;

}
.count-right{
  color: #333333;
  font-size: 24px;
  font-weight: bold;
}
.count-right span{
  color: #ED3939;
  font-size: 32px;
}
.qr_code{
  display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 70px;
    background-color: #ffffff;
    border-top: 1px solid #eeeeee;
    border-radius: 0 0 10px 10px;
    padding: 10px 30px;
    font-size: 24px;
}
.combination_button {
  display: flex;
  margin-left: 15px;
}
.offline{
  display: flex;
        justify-content: center;
        align-items: center;
        width: 174px;
        height: 50px;
        background-color: #999999;
        border-radius: 0px 32px 32px 0px;
        color: #fff;
}
.exchange{
  display: flex;
        justify-content: center;
        align-items: center;
        width: 174px;
        height: 50px;
        background-color: var(--buttonColor);
        color: var(--textColor);
        border-radius: 32px 0px 0px 32px;
}
.exchange> img{
  width: 30px;
          height: 30px;
          margin-right: 2px;
}
.refundButton{
  color: #999;
  padding: 8px 22px;
  background-color: #fff;
  border: 1px solid #999;
  border-radius: 32px;
}
.exchange > span{
  color: var(--textColor);
          font-weight: 500;
}

</style>
